import api from '../../services/api';
import ResponseError, { ErrorCode } from '../../types/response/ResponseError';
import axios, { CancelTokenSource } from 'axios';
import { PagingResponseData } from '../../types/response/PagingResponseData';
import { Organization } from '../../types/b2b/Organization';

export const addBuyer = async (
    organizationId: string,
    email: string,
    firstName: string,
    lastName: string,
    phoneNumber: string,
    registrationNumber: string,
    country: string,
    addBuyerStarted: () => void,
    addBuyerSucceeded: () => void,
    addBuyerFailed: (error: ResponseError) => void
) => {
    addBuyerStarted();

    try {
        await api.post<{
            organizationNumber: string;
            email: string;
            firstName: string;
            lastName: string;
            phoneNumber: string;
            registrationNumber: string;
            countryCode: string;
        }>(
            `api/b2b/${country}/buyers/internal`,
            {
                organizationNumber: organizationId,
                email,
                firstName,
                lastName,
                phoneNumber,
                registrationNumber,
                countryCode: country,
            },
            window.location.origin
        );
        addBuyerSucceeded();
    } catch (error) {
        addBuyerFailed(error as ResponseError);
    }
};

export const searchOrganizations = async (
    searchTerm: string,
    country: string,
    searchStarted: (phrase: string, cancelToken: CancelTokenSource) => void,
    searchSucceeded: (data: PagingResponseData<Organization[]>) => void,
    searchFailed: (error: ResponseError) => void,
    searchCanceled: () => void
) => {
    const source = axios.CancelToken.source();

    searchStarted(searchTerm, source);

    try {
        const response = await api.get<PagingResponseData<Organization[]>>(
            `api/b2b/${country}/organization/internal/search?query="${searchTerm}"`,
            source.token,
            undefined,
            undefined,
            window.location.origin
        );

        searchSucceeded(response);
    } catch (error) {
        const parsedError = error as ResponseError;

        if (parsedError.code === ErrorCode.CLIENT_CANCELED_ERROR) {
            searchCanceled();
        } else {
            searchFailed(error as ResponseError);
        }
    }
};
